import { render, staticRenderFns } from "./SelectDropdown.vue?vue&type=template&id=bb4f68f4&scoped=true&"
import script from "./SelectDropdown.vue?vue&type=script&lang=js&"
export * from "./SelectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SelectDropdown.vue?vue&type=style&index=0&id=bb4f68f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../demo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4f68f4",
  null
  
)

export default component.exports